// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VCharts from 'v-charts'
import App from './App'
import router from './router'
import store from './store'
import fetch, { Network } from './utils/fetch.js'
import {
  storyTypes,
  roleList,
  needStatus,
  loveboxTradeStatuses,
  needDealStatus,
  needShipWays,
  thingCategory,
  giftDealStatus,
  loveboxItemStatuses,
  edmStatus,
  fbStatusList,
  PURCHASE_FROM
} from './utils/constant'
import Icon from 'vue-awesome'
import UserTags from './components/UserTags'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(VCharts)
Vue.component('icon', Icon)
Vue.component('user-tags', UserTags)
Vue.prototype.$http = fetch
Vue.prototype.$network = Network

Vue.directive('permission', {
  inserted: (el, binding, vnode) => {
    if (store.getters.roles.includes('visitor')) {
      el.parentNode.removeChild(el)
    }
  }
})

Vue.filter('storyType', function (value) {
  if (!value) return ''
  for (const type of storyTypes) {
    if (type.id === value) {
      return type.title
    }
  }
  return ''
})
Vue.filter('gender', function (value) {
  if (!value) return ''
  switch (value) {
    case 'MALE': return '男'
    case 'FEMALE': return '女'
    case 'OTHER': return '保密'
    default: return '保密'
  }
})
Vue.filter('genderColor', function (value) {
  if (!value) return ''
  switch (value) {
    case 'MALE': return 'color-blue'
    case 'FEMALE': return 'color-pink'
    case 'OTHER': return 'color-gray-deep'
    default: return 'color-gray-deep'
  }
})
Vue.filter('yesOrNo', function (value) {
  if (!value) return ''
  if (value === 'Y' || value === 1) {
    return '是'
  } else {
    return '否'
  }
})
Vue.filter('yesOrNoColor', function (value) {
  if (!value) return ''
  if (value === 'Y' || value === 1) {
    return 'color-green'
  } else {
    return 'color-orange'
  }
})
Vue.filter('incomes', function (value) {
  if (!value) return '-'
  const options = [
    { text: '0-30萬', value: '0' },
    { text: '30-60萬', value: '30' },
    { text: '60-100萬', value: '60' },
    { text: '100-200萬', value: '100' },
    { text: '200萬以上', value: '200' }
  ]
  for (const option of options) {
    if (option.value === value) {
      return option.text
    }
  }
  return '-'
})
Vue.filter('role', function (value) {
  if (!value) return '-'
  for (const role of roleList) {
    if (value === role.id) {
      return role.label
    }
  }
  return ''
})
Vue.filter('itemStatus', function (value) {
  if (!value) return '-'
  for (const role of needStatus) {
    if (value === role.value) {
      return role.label
    }
  }
  return '-'
})
Vue.filter('itemStatusClass', function (value) {
  if (!value) return '-'
  for (const role of needStatus) {
    if (value === role.value) {
      return role.className
    }
  }
  return '-'
})
// 需求交易状态过滤器
Vue.filter('needDealStatus', (value) => {
  if (!value) return '-'
  for (const item of needDealStatus) {
    if (value === item.value) {
      return item.label
    }
  }
  return '-'
})
// GC代贈訂單索取状态过滤器
Vue.filter('giftDealStatus', (value) => {
  if (!value) return '-'
  for (const item of giftDealStatus) {
    if (value === item.value) {
      return item.label
    }
  }
  return '-'
})
// 礼物索取状态过滤器
Vue.filter('giftDealStatus', (value) => {
  if (!value) return '-'
  for (const item of giftDealStatus) {
    if (value === item.value) {
      return item.label
    }
  }
  return '-'
})

// EDM状态过滤器
Vue.filter('edmStatus', (value) => {
  if (!value) return '-'
  for (const item of edmStatus) {
    if (value === item.value) {
      return item.label
    }
  }
  return '-'
})

// 货运方式状态过滤器
Vue.filter('shipway', (value) => {
  if (!value) return '-'
  for (const item of needShipWays) {
    if (value === item.value) {
      return item.label
    }
  }
  return '-'
})

// 物品分类状态过滤器
Vue.filter('thingCategory', (value) => {
  if (!value) return '-'
  for (const item of thingCategory) {
    if (value === item.value) {
      return item.label
    }
  }
  return '-'
})

// 交易状态过滤器
Vue.filter('loveboxTradeStatus', (value) => {
  for (const item of loveboxTradeStatuses) {
    if (value === item.value) {
      return item.label
    }
  }
  return '-'
})

// 交易状态过滤器
Vue.filter('loveboxItemStatus', (value) => {
  for (const item of loveboxItemStatuses) {
    if (value === item.value) {
      return item.label
    }
  }
  return '-'
})

Vue.filter('feedbackStatus', (value) => fbStatusList.find(item => item.value === value).label)

Vue.filter('notifyCategory', (value) => {
  switch (value) {
    case 'commonweal':
      return '公益團體'
    case 'care':
      return '關懷會員'
    case 'charitys':
      return '公益捐贈會員'
    case 'specified':
      return '指定會員'
    default:
      return '所有'
  }
})

Vue.filter('purchaseFromFilter', (value) => {
  for (const item of PURCHASE_FROM) {
    if (value === item.value) {
      return item.label
    }
  }
  return '-'
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js